/* eslint-disable @typescript-eslint/no-explicit-any, jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import { BellRing, Calculator, Gavel } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
import { Input } from '@/ui/base/input';
const NS = '/bff/v1/j09-s02-calcular-notificar';
export function EnquadrarNotificarPage() {
  const [e, setE] = useState<any>();
  const [busy, setBusy] = useState(false);
  const [codigo, setCodigo] = useState('DESCUMPRIMENTO_SERVICO');
  const [descricao, setDescricao] = useState('Descumprimento comprovado da prestação autorizada');
  const [pct, setPct] = useState('5');
  const [inicio, setInicio] = useState(new Date().toISOString().slice(0, 10));
  const [fim, setFim] = useState('2099-12-31');
  const [dias, setDias] = useState('10');
  const [ocorrencia, setOcorrencia] = useState('');
  const [regra, setRegra] = useState('');
  async function call(path: string, body?: any) {
    setBusy(true);
    try {
      const x = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo: body,
      });
      setE(x.state);
      return x.state;
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  useEffect(() => {
    if (e) {
      if (!ocorrencia) setOcorrencia(e.ocorrencias[0]?.id ?? '');
      if (!regra) setRegra(e.regras.find((r: any) => r.ativo)?.id ?? '');
    }
  }, [e, ocorrencia, regra]);
  if (!e) return <p role="status">Carregando enquadramentos…</p>;
  const q = e.enquadramentos[0];
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <Gavel className="mr-2 inline h-7 w-7" />
          {e.titulo}
        </h1>
        <p>{e.descricao}</p>
      </header>
      {e.alertas.map((a: any) => (
        <div role="alert" key={a.codigo} className="rounded-md border border-destructive p-3">
          {a.mensagem} <code>{a.codigo}</code>
        </div>
      ))}
      <section className="grid gap-3 rounded-md border p-4 md:grid-cols-2">
        <h2 className="col-span-full font-semibold">Catálogo versionado</h2>
        <label>
          Código
          <Input value={codigo} onChange={(x) => setCodigo(x.target.value)} />
        </label>
        <label>
          Descrição
          <Input value={descricao} onChange={(x) => setDescricao(x.target.value)} />
        </label>
        <label>
          Percentual
          <Input type="number" value={pct} onChange={(x) => setPct(x.target.value)} />
        </label>
        <label>
          Prazo de defesa (dias)
          <Input type="number" value={dias} onChange={(x) => setDias(x.target.value)} />
        </label>
        <label>
          Início
          <Input type="date" value={inicio} onChange={(x) => setInicio(x.target.value)} />
        </label>
        <label>
          Fim
          <Input type="date" value={fim} onChange={(x) => setFim(x.target.value)} />
        </label>
        <Button
          disabled={busy}
          onClick={() =>
            void call('/verbs/cadastrar_regra', {
              codigo,
              descricao,
              percentual: Number(pct),
              vigenciaInicio: inicio,
              vigenciaFim: fim,
              prazoDefesaDias: Number(dias),
              chaveIdempotencia: crypto.randomUUID(),
            })
          }
        >
          Registrar versão da regra
        </Button>
      </section>
      <section className="space-y-3 rounded-md border p-4">
        <h2 className="font-semibold">
          <Calculator className="mr-2 inline h-5 w-5" />
          Enquadramento e memória
        </h2>
        <label>
          Ocorrência
          <select
            className="block h-10 w-full rounded-md border bg-background px-3"
            value={ocorrencia}
            onChange={(x) => setOcorrencia(x.target.value)}
          >
            {e.ocorrencias.map((o: any) => (
              <option key={o.id} value={o.id}>
                {o.protocolo} · {o.credenciado}
              </option>
            ))}
          </select>
        </label>
        <label>
          Regra
          <select
            className="block h-10 w-full rounded-md border bg-background px-3"
            value={regra}
            onChange={(x) => setRegra(x.target.value)}
          >
            {e.regras.map((r: any) => (
              <option key={r.id} value={r.id}>
                {r.codigo} v{r.versao} · {r.percentual}% · {r.vigencia_inicio} a {r.vigencia_fim}
              </option>
            ))}
          </select>
        </label>
        <Button
          disabled={busy || !ocorrencia || !regra}
          onClick={() =>
            void call('/verbs/enquadrar_calcular', {
              ocorrenciaId: ocorrencia,
              regraId: regra,
              chaveIdempotencia: crypto.randomUUID(),
            })
          }
        >
          Calcular proposta
        </Button>
        {q && (
          <article className="rounded-md bg-muted p-3">
            <p>
              <strong>{q.protocolo}</strong> · {q.regra_codigo} v{q.regra_versao}
            </p>
            <p>
              Base R$ {q.valor_base} × {q.percentual}% = <strong>R$ {q.valor_proposto}</strong>
            </p>
            <p className="break-all font-mono text-xs">Memória {q.memoria_hash}</p>
          </article>
        )}
      </section>
      {q && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">
            <BellRing className="mr-2 inline h-5 w-5" />
            Notificação e entrega
          </h2>
          {!q.notificacao_id ? (
            <Button
              disabled={busy}
              onClick={() =>
                void call('/verbs/emitir_notificacao', {
                  enquadramentoId: q.id,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Emitir inteiro teor
            </Button>
          ) : (
            <>
              <p>
                <strong>{q.numero}</strong> · {q.notificacao_status}
              </p>
              <p>{q.inteiro_teor}</p>
              <p>Defesa: {q.canal_defesa}</p>
              <div className="flex flex-wrap gap-2">
                <Button
                  variant="outline"
                  disabled={busy}
                  onClick={() =>
                    void call('/verbs/registrar_entrega', {
                      notificacaoId: q.notificacao_id,
                      entregue: false,
                      comprovante: 'Falha técnica registrada pelo sistema',
                      chaveIdempotencia: crypto.randomUUID(),
                    })
                  }
                >
                  Registrar falha
                </Button>
                <Button
                  disabled={busy}
                  onClick={() =>
                    void call('/verbs/registrar_entrega', {
                      notificacaoId: q.notificacao_id,
                      entregue: true,
                      comprovante: 'Entrega eletrônica confirmada',
                      chaveIdempotencia: crypto.randomUUID(),
                    })
                  }
                >
                  Confirmar entrega válida
                </Button>
              </div>
              {q.prazo_defesa_em && (
                <p>
                  Prazo de defesa até{' '}
                  <strong>{new Date(q.prazo_defesa_em).toLocaleString('pt-BR')}</strong>
                </p>
              )}
            </>
          )}
        </section>
      )}
      {e.resultado && (
        <p role="status" className="rounded-md border border-primary p-3">
          Operação persistida: {JSON.stringify(e.resultado)}
        </p>
      )}
    </main>
  );
}
